module.exports = __webpack_public_path__ + "static/media/walt_disney_white.66fb80ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walt_disney_white.png
// module id = 1125
// module chunks = 0